import { XdrOverviewView } from '../view/XdrOverviewView';
import { templateXdrOverview } from '../view/template';
import { BaseWebComponentController } from '../../../framework/BaseWebComponentController';
import { XdrOverviewWebComponent } from '..';
import { XdrOverviewWebComponentSchema } from '../types';
import { EventsName } from '../../organizationalImpact/types/types';
import { SideMenuEvents } from '../../../ui/gzSideMenu/types';

export class XdrOverviewController extends BaseWebComponentController {
  public component: XdrOverviewWebComponent;
  public view: XdrOverviewView;
  public viewConstructor: typeof XdrOverviewView;

  constructor(component: XdrOverviewWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: XdrOverviewView,
      viewTemplate: templateXdrOverview,
    });
  }

  async getDataForView(): Promise<XdrOverviewWebComponentSchema> {
    return this.component.incidentData;
  }

  computeEventListeners() {
    return [
      {
        element: this.view.dom.$organizationalImpactCard,
        event: EventsName.ENTITIES_CLICK,
        callback: this.handleEntitiesClick.bind(this),
      },
      {
        element: this.view.dom.$organizationalImpactCard,
        event: EventsName.RESOURCES_CLICK,
        callback: this.handleResourcesClick.bind(this),
      },
      {
        element: this.view.dom.$xdrOverviewContent,
        event: SideMenuEvents.CLOSE,
        callback: this.handleSideMenuClose.bind(this),
      },
    ];
  }

  handleEntitiesClick(event: CustomEvent) {
    this.view.handleEntitiesClick(event);
  }

  handleResourcesClick(event: CustomEvent) {
    this.view.handleResourcesClick(event);
  }

  handleSideMenuClose() {
    this.view.handleSideMenuClose();
  }
}
